import { getCardById } from './CardEventData';

export const getInitialCard = () => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const cardId = params.get('cardId');
    return cardId ? getCardById(Number(cardId)) : null;
  }
  return null;
};